export default __webpack_public_path__ + "static/media/exit.1b4fc5ae.svg";